import { Get } from 'Xhr/Xhr';
import { useAtom } from 'jotai';
import React, { useEffect } from 'react';
import { IconAtom } from './IconAtom';
import { env } from 'env';

const useCacheIcons = () => {
  const [, setIcon] = useAtom(IconAtom);
  useEffect(() => {
    Get(
      `${process.env.REACT_APP_API_URL_API_GET_APP_ICONS}`,
      false,
      {}
    ).then((response) => {
      if (response.data.resCode === 1) {
        // console.log('response data =>',response.data)
        localStorage.setItem(
          'icons',
          JSON.stringify(response.data.Data)
        );
        setIcon(response.data.Data);
      }
    });
  }, []);
};

export default useCacheIcons;
